var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fontFamily: "none",
    fontSize: "none",
    fontWeight: "none",
    style: {
      mixBlendMode: "normal"
    },
    fill: "none",
    strokeMiterlimit: 10,
    textAnchor: "none"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 172V0h172v172Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.9 97.467c.358-2.509.717-5.017.717-7.884 0-2.866-.359-5.375-.717-7.883l16.125-11.467c1.433-1.075 2.15-3.225 1.075-5.016L143.333 38.7c-1.075-1.792-2.866-2.508-4.658-1.433l-17.917 8.241c-4.3-3.225-8.6-5.733-13.616-7.883l-1.792-19.708c-.358-1.792-1.792-3.225-3.583-3.225H70.95c-1.792 0-3.583 1.433-3.583 3.225l-1.792 19.708c-5.017 2.15-9.675 4.658-13.617 7.883l-17.917-8.241c-1.791-.717-3.941 0-4.658 1.433L13.975 65.217c-1.075 1.791-.358 3.941 1.075 5.016L31.175 81.7c-.358 2.508-.717 5.017-.717 7.883 0 2.867.359 5.375.717 7.884l-16.842 11.466c-1.433 1.075-2.15 3.225-1.075 5.017l15.408 26.517c1.075 1.791 2.867 2.508 4.659 1.433l17.916-8.242c4.3 3.225 8.6 5.734 13.617 7.884l1.792 19.708c.358 1.792 1.792 3.225 3.583 3.225h30.817c1.792 0 3.583-1.433 3.583-3.225l1.792-19.708c5.017-2.15 9.675-4.659 13.617-7.884l17.916 8.242c1.792.717 3.942 0 4.659-1.433l15.408-26.517c1.075-1.792.358-3.942-1.075-5.017ZM86 125.417c-19.708 0-35.833-16.125-35.833-35.833C50.167 69.875 66.292 53.75 86 53.75s35.833 16.125 35.833 35.834c0 19.708-16.125 35.833-35.833 35.833Z",
    style: {
      fill: "#677b84",
      fillOpacity: 1
    },
    fill: "#607d8b"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86 46.583c-23.65 0-43 19.35-43 43s19.35 43 43 43 43-19.35 43-43-19.35-43-43-43Zm0 60.917c-10.033 0-17.917-7.883-17.917-17.917 0-10.033 7.884-17.916 17.917-17.916 10.033 0 17.917 7.883 17.917 17.916 0 10.034-7.884 17.917-17.917 17.917Z",
    fill: "#455a64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.20ebc8a2de0edfce840af9cf3af46f04.svg";
export { ForwardRef as ReactComponent };